import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"

export function useRiskZoneMutation(
    url,
    axiosFn,
    queryParameters,
    config = {},
) {
    const apiUrl = `risk_zone/${url}`

    return useAuthenticatedMutation(
        apiUrl,
        axiosFn,
        queryParameters,
        config,
    )
}